import AlertsService from '@services/alerts-service';
import { AlertSettings } from '@interfaces/models/alertSettings';
import { AxiosError } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { ApiResponse, ApiResponseError } from '@interfaces/api';
import { Alert } from '@interfaces/models/alert';

interface UseCreateAlert {
  onMutate?: () => void;
  onCreateFinished?: () => void;
  onCreateSuccess?: (data: ApiResponse<{ data: Alert }>) => void;
  onCreateError?: (error: AxiosError<{ errors: ApiResponseError }>) => void;
}

const useCreateAlert = ({ onCreateFinished, onCreateSuccess, onCreateError, onMutate }: UseCreateAlert) => {
  const { mutate: createAlertMutateFn } = useMutation<
    ApiResponse<{ data: Alert }>,
    AxiosError<{ errors: ApiResponseError }>,
    AlertSettings
  >({
    onMutate,
    mutationFn: (payload) => AlertsService.createAlert(payload),
    onSuccess: onCreateSuccess,
    onError: (error) => onCreateError(error),
    onSettled: onCreateFinished,
  });

  return { createAlertMutateFn };
};

export default useCreateAlert;
